
<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >

           <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
                  <b-card                          
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE PARCELAS"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"
              >
                <b-card-text> 
                  <h2>                    
                  {{ itemsFiltered.length }}     
                  </h2>
                </b-card-text>
              </b-card>            

            <b-card                  
            class="ml-2"
                style="width: 33rem;"
              
              border-variant="success"
              header="VALOR TOTAL R$"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                                              {{ parseFloat(itemsFiltered
    .map(v => parseFloat(v.valor_parcela	) || 0) // Garantir que cada valor seja um número
    .reduce((acumulador, valor_parcela	) => acumulador + valor_parcela	, 0) // Somar os valores
).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
}) }}

                  
                </h2>                
              </b-card-text>
      </b-card>        

      </b-card-group> 



           
          <b-row>

                                              <b-col cols="1">
                                    <b-form-group class="mb-3 mt-3">
                                      <b-form-input @keyup.enter="loadFuncionario()"  v-model="registro" required placeholder="Nº de RE" ></b-form-input>              
                                    </b-form-group>
                                  </b-col>  
            


                                                          <b-col cols="3" class="mb-3 mt-3">
                          <b-input-group-text>
                            {{ funcionarios.nome ? funcionarios.nome : '-' }}
                          </b-input-group-text>
                        </b-col>    



                                                <b-col cols="3" class="mb-3 mt-3">
                          <b-input-group-text>
                            {{ funcionarios.funcao ? funcionarios.funcao : '-' }}
                          </b-input-group-text>
                        </b-col>       

                    <b-col cols="1" class="mb-3 mt-3">
     
                        <b-button class="ml-3 mb-3" variant="warning" block  @click=" gerarPlanilha()">Excel</b-button>
                    </b-col>


          </b-row>
    

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
        <b-table small hover striped sticky-header="100%"  :items="itemsFiltered" :fields="fieldsCliFor">     

                      <template #cell(valor_parcela)="data">
              {{ formatCurrency2(data.item.valor_parcela) }}
            </template>     

                        <template #cell(total)="data">
              {{ formatCurrency2(data.item.total) }}
            </template>           


    </b-table>   
    

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="ModalComprasFuncionario" centered cancel-title="Fechar"  @cancel="loadParcelas()"  @close="loadParcelas()" hide-footer size="xl" title="Itens da compra"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'
import * as XLSX from 'xlsx'

export default {

  computed : { ... mapState (['user'],),

      getStyle() {
      return {
        color: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'red' : '', // Fonte vermelha se não for 'ATIVA'
        background: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'yellow' : '', // Background amarelo se não for 'ATIVA'
      };
    },


  itemsFiltered(){
        let valorefu = [];       
        valorefu = this.parcelasFuncionarios.filter((item) =>{
          const nome = item.nome || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const cnpj = item.cnpj || '';          
          return (
             nome.indexOf(this.search) >-1  ||             
             cnpj.indexOf(this.search) >-1 
          );
        });
        return valorefu
        }

  } ,

    name: 'FuncionarioCadastro',    

    data: function() {
      
      return {
          vendaItens:[],
          funcionarios:[],
          funcionario:{},
          empresa:{}, 
          empresas:[],   // [] lista       
          filial:{}, 
          filiais: [],   // [] lista      
          clifors:[],
          clifor:{},          
          ceps:[],
          vendasFuncionario:{},
          parcelasFuncionarios:[],
          resultadocnpj:{},
          value_cnpj:'',
          areas:[],
          tipos:[],
          escritorios:[],
          search:'',
          registro:'',
/*
            mode: 'save',
            carregando: false,
            atualizando: false,              
            page: 1,
            limitcarro: 0,
            count: 0,
            valor_empresa:'',                                     
            selected: null,
  */          
            fieldsCliFor: [                
              { key: 'dt_lancamento', label: 'Data ', sortable: true, formatter: (value, key, itemsFiltered) => {
                  return moment(itemsFiltered.dt_lancamento).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                
                { key: 're', label: 'Registro', sortable: true },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'funcao', label: 'Função', sortable: true },                
                { key: 'ticket_id', label: 'Ticket', sortable: true },                 
                { key: 'valor_parcela', label: 'R$ Valor da parcela', sortable: true },     
                { key: 'total', label: 'R$ Valor total', sortable: true },       
                              { key: 'dt_desconto', label: 'Data desconto ', sortable: true, formatter: (value, key, itemsFiltered) => {
                  return moment(itemsFiltered.dt_desconto).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },              
                { key: 'tipo_pagto', label: 'Forma Pagto', sortable: true },                       
         
            ]
        }        
    },

    components: {
        Multiselect, LoadingModal
    },

    methods: {
            async loadFuncionario() { 
            let corpo = {                             
            "registro": `${this.registro}`,
            "id_empresa": `${this.user.id_empresa}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.funcionarios = res.data })    
              this.reset()
              this.loadParcelas()              
  
      },  

              formatCurrency2(amount) {
      const number = parseFloat(amount);
      if (isNaN(number)) {
        return 'R$ 0,00'; // Valor padrão se não for um número
      }
      return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },

                    gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.parcelasFuncionarios

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'parcelas_fucnionarios.xlsx');
      },

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

        /*
      async loadParcelas() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "registro": `${this.registro}`,
            "filtro": 'parcelas_funcionario'
                        //"filtro": 'vendafuncionario'
          };
          const url = await`${baseApiUrl}/sambaiba/cf7/financeiro/lancamentos`
          axios.post(url,corpo)
               .then(res => {this.parcelasFuncionarios = res.data})         
              .catch(showError)                                
      }, 
      */

      async loadParcelas() {
  let corpo = {
    "empresa_id": `${this.user.id_empresa}`,
    "registro": `${this.registro}`,
    "filtro": 'parcelas_funcionario' // ou 'vendafuncionario', dependendo do caso
  };

  const url = `${baseApiUrl}/sambaiba/cf7/financeiro/lancamentos`; // Corrigido para uso correto da template string

  try {
    const response = await axios.post(url, corpo);
    this.parcelasFuncionarios = response.data;
  } catch (error) {
    if (error.response) {
      // A resposta do servidor foi recebida com um código de status de erro
      if (error.response.status === 404) {
          // Verifica a mensagem específica do servidor
        const errorMessage = error.response.data.message || 'Sem dados';
        showError(errorMessage); // Exibe a mensagem recebida do servidor
      } else {
        showError(`Erro: ${error.response.status} - ${error.response.statusText}`);
      }
    } else if (error.request) {
      // A solicitação foi feita, mas nenhuma resposta foi recebida
      showError('Erro ao conectar com o servidor');
    } else {
      // Algo aconteceu ao configurar a solicitação
      showError('Erro desconhecido');
    }
  }
},


      

      
      putItens(parcelasFuncionarios) {            
            this.vendasFuncionario = { ...parcelasFuncionarios}
            
      },

      async loadVendaItens() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "ticket_id": `${this.vendasFuncionario.ticket_id}`,
            "filtro": 'vendaItens'
          };
          const url = await`${baseApiUrl}/sambaiba/cf7/produtocad`
          axios.post(url,corpo)
               .then(res => {this.vendaItens = res.data})         
              .catch(showError)                                
      }, 
      
      reset() {                  
            this.parcelasFuncionarios = []                     
      },      
    },

    watch: {
      page() {
        this.loadVeiculos()
      }
    },

    mounted() {  
    //  this.loadEmpresas()
    //  this.loadArea()
    //  this.loadTipo()      
     // this.loadEscritório()
      
      /*
      this.loadFiliais()
      this.loadVeiculos() 
      this.loadFabricanteChassi()            
      this.loadModeloChassi()
      this.loadcliforStatus()
      this.loadCarroceriaFabricante()
      this.loadCarroceriaModelo()     
      this.loadTipoFrota()
      this.loadLote()
      */

      
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

#selecaostatusx{
    font-size: 0.7em;      
}

</style>
